export default __webpack_public_path__ + "static/media/flag.44571d53.svg";